import { ClientesService } from '@modules/clientes/services/clientes.service';
import { Utilservice } from '@core/services/util.service';
import { Component, OnInit, } from '@angular/core';

interface ClienteCarteiraFuturaDTO {
  id: number,
  razaoSocial: string,
  cnpj: string,
  setorCdfzs: string,
}

@Component({
  selector: 'app-carteira-futura-modal',
  templateUrl: './carteira-futura-modal.component.html',
  styleUrls: ['./carteira-futura-modal.component.css']
})
export class CarteiraFuturaModalComponent implements OnInit {
  lsCarteiraFutura = [];
  valorTotalCarteiraFutura = 0;
  cliente: ClienteCarteiraFuturaDTO = null;

  loading = false;

  constructor(
    private clientService:  ClientesService
  ) { }

  ngOnInit() {
  }

  openModal(cliente: ClienteCarteiraFuturaDTO){
    this.cliente = cliente;

    document.getElementById("openModalButton").click();

    this.getCarteiraFutura();
  }

  getCarteiraFutura(){
    this.loading = true;

    this.clientService.getCarteiraFutura(this.cliente.id)
      .finally(() => (this.loading = false))
      .subscribe(
        data => {
          if(data.length > 0){
            this.lsCarteiraFutura = data

            this.valorTotalCarteiraFutura = this.getTotalCarteiraFutura()
          }
        },
        error => {
          toastr.error('Ocorreu um erro ao carregar a carteira futura')
          console.log(error)
        }
      )
  }

  formatDate(date){
    return Utilservice.formatDate(date)
  }

  resetModal(){
    this.cliente = null;
    this.valorTotalCarteiraFutura = 0;
    this.lsCarteiraFutura = []
  }

  // metodos privados

  private getTotalCarteiraFutura(){
    return this.lsCarteiraFutura.reduce(
      (previus, current) =>
        previus + current.valorItemPedido,
      0
    )
  }

}
